module.exports = __webpack_public_path__ + "static/media/us.cb42454e.jpg";